import { AlertTriangle, CircleAlert, CircleCheck, Info } from 'lucide-react'
import { AlertDescription, AlertTitle, Alert as ShadAlert } from 'primitives/base/alert'
import type * as React from 'react'

type AlertProps = {
  variant: 'info' | 'destructive' | 'default' | 'warning' | 'success' | 'secondary'
  title?: string | React.ReactNode
  content?: React.ReactNode
  icon?: React.ReactNode
  className?: string
}

export const iconMap = {
  info: <Info size={16} />,
  default: <Info size={16} />,
  warning: <AlertTriangle size={16} />,
  success: <CircleCheck size={16} />,
  destructive: <CircleAlert size={16} />, // You can change this icon if you prefer a different one for errors
  secondary: <Info size={16} />,
}

export const Alert = ({ variant = 'info', title, content, icon, className }: AlertProps) => {
  const selectedIcon = icon || iconMap[variant]

  return (
    <ShadAlert variant={variant} className={className}>
      <div data-slot="alert-icon" className="mt-[2px] shrink-0">
        {selectedIcon}
      </div>
      <div>
        {title && typeof title === 'string' ? (
          <AlertTitle className="text-p-600 mb-[3px]">{title}</AlertTitle>
        ) : (
          title
        )}
        <AlertDescription className={title ? 'text-xs-400' : 'text-s-400'}>
          {content}
        </AlertDescription>
      </div>
    </ShadAlert>
  )
}
